export default "__VITE_ASSET__BZeywgpn__"